// src/api/api.js
import axios from 'axios';
import Helpers from '@utils/Helpers'

const apiMap = axios.create({
    baseURL: process.env.REACT_APP_MAP_API,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor for request
apiMap.interceptors.request.use(
    (config) => config,
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor for response
apiMap.interceptors.response.use(
    (response) => response,
    async (error) => {
        return Promise.reject(error);
    }
);
// ======================================================
const apiGoogle = axios.create({
    baseURL: process.env.REACT_APP_GOOGLE_API,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor for request
apiGoogle.interceptors.request.use(
    (config) => {
        const token = Helpers.getAccessToken();
        if (token) {
            config.headers.Authorization = `BEARER ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// Interceptor for response
apiGoogle.interceptors.response.use(
    (response) => response,
    async (error) => {
        return Promise.reject(error);
    }
);
// =======================================================

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_HAY2U_ENDPOINT,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
        "ngrok-skip-browser-warning": "true"
    },
});

// Interceptor for request
apiClient.interceptors.request.use(
    (config) => {
        const token = Helpers.getAccessToken();
        if (token) {
            config.headers.Authorization = `BEARER ${token}`;
        }
        return config
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor for response
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.message == "timeout of 20000ms exceeded") {
            return
        }
        if (error.config.url == "/auth/verify") {
            return Promise.reject(error);
        }
        // Check if token is expired and hasn't tried to refresh token
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // Call Refresh Token Api
                const refreshToken = Helpers.getRefreshToken();

                const refreshResponse = await axios.post(`${process.env.REACT_APP_HAY2U_ENDPOINT}/auth/refresh`, { refresh_token: refreshToken });

                if (refreshResponse.status === 200) {
                    // Store New Access Token
                    const newAccessToken = refreshResponse.data.data.access_token;
                    const newRefreshToken = refreshResponse.data.data.refresh_token;
                    Helpers.storeAccessToken(newAccessToken);
                    Helpers.storeRefreshToken(newRefreshToken);

                    // Update Authorization header
                    originalRequest.headers['Authorization'] = `BEARER ${newAccessToken}`;
                    apiClient.defaults.headers["Authorization"] = `BEARER ${newAccessToken}`;

                    return apiClient(originalRequest);
                }
            } catch (refreshError) {
                Helpers.clearToken();
                Helpers.removeUserInfo();
                Helpers.removeUserAddress();
                Helpers.removeGallery();
                Helpers.redirect('/auth')
            }
        }
        return Promise.reject(error);
    }
);
export { apiGoogle, apiClient, apiMap };
